export default __webpack_public_path__ + "static/media/may.0b244fae.jpg";